import { provideHttpClient, withInterceptorsFromDi,
    withXhr
} from '@angular/common/http';
import { NgModule, inject, provideAppInitializer,
    provideZoneChangeDetection
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideTippyConfig, provideTippyLoader, tooltipVariation } from '@ngneat/helipopper/config';

import { definePreset, usePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { provideOptimus } from '@openng/optimus-ui/config';
import { AppTemplateModule } from 'src/modules/app-template/app-template.module';
import { CorporateIdentityTools } from 'src/modules/app-template/models/corporate-identity.model';
import { Config } from 'src/modules/app-template/models/config.model';
import { MainFrontendConfig } from 'src/modules/app-template/netgen/MainFrontendConfig';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';




import { EnaioDocumentsModule } from 'src/modules/enaio-documents/enaio-documents.module';






import { PrimeModule } from 'src/modules/prime/prime.module';
import { ProjectPlanningModule } from 'src/modules/project-planning/project-planning.module';

import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { SmBaseModule } from 'src/modules/sm-base/sm-base.module';

import { Utils } from 'src/modules/utils/shared/utils';
import { AppRoutes } from './app.routes';
import { RootComponent } from "./components/root/root.component";

export function init_app(app: MainAppService) {
    return async () => {
        app.setMainConfig(await loadMainConfig());
        await app.auth.updateUserDetails();
        usePreset(definePreset(Aura, CorporateIdentityTools.getPrimePreset(app.mainConfig.corporateIdentity)));

        ModuleRegistry.registerModules([AllCommunityModule]);

        if (!Utils.isNoe(app.mainConfig.agGridEnterpriseKey)) {
            ModuleRegistry.registerModules([AllEnterpriseModule]);
            LicenseManager.setLicenseKey(app.mainConfig.agGridEnterpriseKey);
        }

        provideGlobalGridOptions({
            theme: "legacy",
            suppressSetFilterByDefault: true
        });

        await app.setLanguage(null);

        await app.featureModules.beforeAppStart();
    };
}

async function loadMainConfig(): Promise<MainFrontendConfig> {
    try {
        return await RestEndpoint.main().find({cacheBust: Date.now()}).run("api/app/mainConfig").get(MainFrontendConfig);
    }
    catch {
        await Utils.sleep(500);
        return await RestEndpoint.main().find({cacheBust: Date.now()}).run("api/app/mainConfig").get(MainFrontendConfig);
    }
}

@NgModule({
    declarations: [RootComponent],
    imports: [
        BrowserModule,
        PrimeModule,
        AppTemplateModule,
        AppRoutes,
        EnaioDocumentsModule,
        
        
        
        
        
        
        
        
        
        
        ProjectPlanningModule,
        
        
        SmBaseModule /*, TODO Kann wieder aktiviert werden, wenn der Worker dann wirklich implementiert ist
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: Config.get().production })*/], providers: [
        provideAppInitializer(() => {
            const initializerFn = init_app(inject(MainAppService));
            return initializerFn();
        }),
        provideTippyLoader(() => import('tippy.js')),
        provideTippyConfig({
            defaultVariation: 'tooltip',
            variations: {
                tooltip: {
                    ...tooltipVariation,            
                    theme: 'light'
                },
            },
        }),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideZoneChangeDetection({
            eventCoalescing: true,
            runCoalescing: true
        }),
        provideOptimus({
            theme: { 
                preset: Aura,
                options: {
                    darkModeSelector: '.dark-mode'
                }
            }
        })
    ],
    bootstrap: [RootComponent]
})
export class AppModule {

    app = inject(MainAppService);

    constructor() {
        this.app.appName = this.app.mainConfig?.appName || this.app.appName;
        this.app.pageTitle = this.app.appName;
    }
}
